import SelectedFund from './SelectedFund';

export default SelectedFund;
